<template>
  <div class="auth__wrapper">
    <div class="user">
      <div class="user-wrapper" v-click-outside="() => (isOpenUserDropMenu = false)">
        <div class="user-wrapper__block">
          <div class="user-wrapper__block-content">
            <p class="user-wrapper__block-nick">{{ $store.state.account.username }}</p>
            <div class="user-wrapper__block-total">
              <p class="user-wrapper__block-total__balance">
                {{ $store.getters.balance.toFixed(2) }} {{ $store.getters.currencySign }}
              </p>
              <router-link to="/payment" class="user-wrapper__block-total__add">
                <Icon name="/base/plus.svg" />
              </router-link>
            </div>
          </div>
        </div>
        <div class="user-wrapper__avatar" @click="openDropMenu">
          <template v-if="!imgError">
            <img
              v-if="$store.state.account.isVk"
              :src="$store.state.account.avatarUrl"
              alt=""
              @error="imgError = true"
            />
            <img
              v-if="$store.state.account.isVk === 0"
              :src="require(`@/assets/images/navigation/avatar-${$store.state.account.avatarId}.png`)"
              alt=""
              @error="imgError = true"
            />
          </template>
        </div>
        <div class="user-wrapper__block-arrow" :class="{ openMenu: isOpenUserDropMenu }" @click="openDropMenu">
          <Icon name="/base/arrow.svg" />
        </div>
      </div>
      <!--      -->
      <div
        class="user-dropdown"
        :class="{ openDropDown: isOpenUserDropMenu }"
        @click="isOpenUserDropMenu = !isOpenUserDropMenu"
      >
        <ul>
          <li>
            <router-link to="/history">{{ $t('navigation.dropdown.history') }}</router-link>
          </li>
          <li v-if="$store.state.account.isVk !== 1">
            <a href="#" @click="$store.commit('stateChangePassword')">
              {{ $t('navigation.dropdown.changePassword') }}
            </a>
          </li>
          <li @click="copyId">
            <a href="#">{{ $t('navigation.dropdown.copyId') }}</a>
          </li>
          <li class="exit" @click="$store.dispatch('logOut')">
            <Icon name="/SignIn/logout.svg" />
            <a href="#">{{ $t('navigation.dropdown.logout') }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="auth__wrapper__balance">
      <p>{{ $store.getters.balance.toFixed(2) }} {{ $store.getters.currencySign }}</p>
      <p class="add">
        <router-link to="/payment">
          <Icon name="/SignIn/plus.svg" />
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Base/Icon/Icon.vue'
import { clickOutside } from '@/directives/clickOutside'
import { copyText } from '@/utils/copyText'

export default {
  name: 'AuthWrapper',
  components: { Icon },
  directives: {
    clickOutside
  },
  data() {
    return {
      isOpenUserDropMenu: false,
      visibleAdaptiveBalance: false,
      imgError: false
    }
  },

  computed: {},
  methods: {
    // openUserMenu() {
    //   if (document.body.clientWidth <= 965) this.$store.state.isOpenUserDropMenu = true
    // },
    copyId() {
      copyText(this.$store.state.account.userId)
    },
    openDropMenu() {
      this.isOpenUserDropMenu = !this.isOpenUserDropMenu
    }
  }
}
</script>
<style lang="scss" scoped>
@import './auth-wrapper';
</style>
